import React, { useEffect, useState, useRef } from "react";
import boliviaJson from "./Bolivia.json";
import ReactECharts from "echarts-for-react";
import { registerMap } from "echarts/core";
import { geoMercator } from "d3-geo";
import axios from "axios";
import { URL_API } from "../../../Services/EndPoint";

const EChart = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentosConPorcentaje, setDepartamentosConPorcentaje] = useState([]);
  const [datosOriginales, setDatosOriginales] = useState([]);
  const [maxValue, setMaxValue] = useState(0);
  const [anioMin, setAnioMin] = useState(null);
  const [anioMax, setAnioMax] = useState(null);
  const [toolboxPos, setToolboxPos] = useState({ left: 'left', top: '5%' });
  const [chartHeight, setChartHeight] = useState("800px"); // Desktop por defecto

  const chartRef = useRef(null);

  // Ajuste responsive de toolbox y altura del gráfico
  
useEffect(() => {
  const handleResize = () => {
    const width = window.innerWidth;
    if (width < 768) setChartHeight("400px");   // móviles
    else if (width < 1024) setChartHeight("600px"); // tablets
    else setChartHeight("600px"); 

    if (width < 768) setToolboxPos({ left: 'left', top: '0%' });
    else setToolboxPos({ left: 'left', top: '5%' });
  };

  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // Obtener datos
  const fetchData = async () => {
    try {
      const response = await axios.get(`${URL_API}resoluciones/departamento`);
      setDepartamentos(response.data);
    } catch (error) {
      console.error("Error al obtener los datos de departamentos:", error);
    }
  };

  const fetchAnios = async () => {
    try {
      const response = await axios.get(`${URL_API}resolucionesPorAnio`);
      const anios = response.data.map(item => item.anio);
      if (anios.length > 0) {
        setAnioMin(Math.min(...anios));
        setAnioMax(Math.max(...anios));
      }
    } catch (error) {
      console.error("Error al obtener los años:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchAnios();
  }, []);

  useEffect(() => {
    if (departamentos.length > 0) {
      const maxResolution = Math.max(...departamentos.map(item => item.cantidad_resoluciones));
      const maxPercentage = Math.max(...departamentos.map(item => item.porcentaje));
      setMaxValue(Math.max(maxResolution, maxPercentage));

      const nuevosDepartamentosConPorcentaje = boliviaJson.features.map(departamento => {
        const departamentoData = departamentos.find(
          item => item.departamento_nombre === departamento.properties.name
        );
        return {
          name: departamento.properties.name,
          value: departamentoData ? departamentoData.cantidad_resoluciones : 0,
          percentage: departamentoData ? departamentoData.porcentaje : 0
        };
      });

      setDepartamentosConPorcentaje(nuevosDepartamentosConPorcentaje);
      setDatosOriginales(nuevosDepartamentosConPorcentaje);
    }
  }, [departamentos]);

  registerMap("Bolivia", boliviaJson);
  const projection = geoMercator();

  const onChartEvent = (event) => {
    if (event.type === 'restore') {
      setDepartamentosConPorcentaje(datosOriginales);
    }
  };

  const tituloDinamico = anioMin && anioMax
    ? `Resoluciones por Departamento (${anioMin}–${anioMax})`
    : 'Resoluciones por Departamento';

  return (
    <div style={{
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "20px",        // padding general (arriba, izquierda, derecha, abajo)
    paddingBottom: "0px",  // sobrescribe solo el padding de abajo
  }}>
    
      <ReactECharts
        ref={chartRef}
        option={{
          
          title: {
            text: tituloDinamico,
            subtext: "Datos de TCP Bolivia",
            left: "right",
            top: "5%",
            textStyle: { fontSize: 14 },
            subtextStyle: { fontSize: 12 }
          },
          tooltip: {
            trigger: "item",
            formatter: (params) => {
              const { name, value, data } = params;
              return `${name}<br/>Resoluciones: ${value}<br/>Porcentaje: ${data?.percentage || 0}%`;
            },
            textStyle: { fontSize: 14, fontFamily: 'Arial' },
          },
          visualMap: {
            left: "right",
            top: "40%",
            min: 0,
            max: maxValue,
            inRange: { color: ["#4575b4", "#ffffff", "#d73027"] },
            text: ["Alto", "Bajo"],
            calculable: true,
          },
          toolbox: {
            show: true,
            left: toolboxPos.left,
            top: toolboxPos.top,
            emphasis: { iconStyle: { borderColor: '#a0425e', color: '#a0425e' } },
            feature: { saveAsImage: { title: 'Descargar imagen', pixelRatio: 2 } }
          },
          series: [
            {
              name: "Resoluciones",
              type: "map",
              roam: false,
              map: "Bolivia",
              projection: { project: point => projection(point), unproject: point => projection.invert(point) },
              label: { show: true, formatter: (params) => `${params.name}\n${params.data?.percentage || 0}%`, color: "#000", fontSize: 14 },
              emphasis: { itemStyle: { areaColor: "rgba(255, 215, 0, 0.4)" }, label: { show: true, color: "#333" } },
              data: departamentosConPorcentaje,
            },
          ],

graphic: { type: "text", right: 10, bottom: 5, style: { text: "Fuente: Sistema SAMED TCP – Instituto de Investigaciones Jurídico Políticas (IIJP – UMSS)", fontSize: 12, fill: "#555", } }

        }}
        style={{ width: "100%", height: chartHeight }}
        onChartEvent={onChartEvent}
      />
    </div>
  );
};

export default EChart;
